import React from 'react'

const Manual_invitar_usuarios_passwallet_clau = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">
          ¿Cómo invitar a los usuarios a tener Clau Passwallet Storecard?
        </h2>
        <iframe
          src="https://scribehow.com/embed/Como_invitar_a_los_usuarios_a_tener_Clau_Passwallet_Storecard__eWim6OHfQtGO6_NS5t8WbA?as=scrollable"
          className="scribe-iframe-general-86"
          width="100%"
          height="6300"
          allow="fullscreen"
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_invitar_usuarios_passwallet_clau
